<template>
  <v-card transition="dialog-bottom-transition" width="700px">
    <update-password-modal
      :alert-text="alertMeta.text"
      :alert-type="alertMeta.type"
    />
  </v-card>
</template>

<script>
  import UpdatePasswordModal from '@/components/modals/UpdatePasswordModal.vue';
  import { PASSWORD_STATUS } from '@/core/constants/password';
  import { mapGetters } from 'vuex';

  export default {
    name: 'UpdatePasswordStep',
    components: { UpdatePasswordModal },
    computed: {
      ...mapGetters({
        passwordStatus: 'auth/passwordStatus',
      }),
      alertMeta() {
        switch (this.passwordStatus) {
          case PASSWORD_STATUS.MUST_CHANGE:
            return {
              text: 'Por seguridad, debes cambiar tu contraseña antes de continuar',
              type: 'error',
            };
          case PASSWORD_STATUS.EXPIRED:
            return {
              text: 'Tu contraseña ha expirado. Es necesario cambiarla para continuar',
              type: 'error',
            };
          case PASSWORD_STATUS.EXPIRING_SOON:
            return {
              text: 'Tu contraseña está próxima a expirar. Te recomendamos cambiarla pronto',
              type: 'warning',
            };
          case PASSWORD_STATUS.OK:
          default:
            return { text: '', type: null };
        }
      },
    },
  };
</script>
